
import './App.css';
import { AllRoutes } from './sections/AllRoutes';
// import Navbar from './sections/Navbar';



function App() {
  return (
    <div className="App">
      {/* <Navbar/> */}
      <AllRoutes/>
    </div>
  );
}

export default App;
